export default "__VITE_ASSET__u6Nvf4Fm__"